<script setup lang="ts">
import { computed } from 'vue'

import type { ICPAvatarPropTypes } from '~/portal/components/base'

const props = withDefaults(
	defineProps<ICPAvatarPropTypes>(),
	{
		size: 'default'
	}
)

const computedSize = computed<ICPAvatarPropTypes['size']>(() => {
	switch (props.size) {
	case 'default':
		return 120
	case 'md':
		return 80
	case 'sm':
		return 48
	default:
		return props.size
	}
})

const computedColor = computed<string>(() => {
	return props.dark ? 'cp-neutral-600' : 'cp-neutral-0'
})
</script>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<template>
  <VAvatar
    :class="[
      'cp-avatar',
      $attrs.class,
      `cp-avatar--size-${size}`,
      { 'cp-avatar--dark': dark }
    ]"
    :size="computedSize"
    :color="computedColor"
  >
    <slot>
      <VImg
        v-if="img"
        :src="img"
      />
      <span
        v-else
        class="cp-avatar__inner"
      >
        {{ initials }}
      </span>
    </slot>
  </VAvatar>
</template>

<style lang="scss">
  .cp-avatar {
    @apply
      border
      border-solid
      border-cp-neutral-100
      font-medium
      ;

    &__inner {
      @apply
        uppercase
        text-cp-neutral-500
      ;
    }

    &--dark {
      @apply
        text-cp-neutral-0
        border-cp-neutral-500
      ;

      .cp-avatar__inner {
        @apply
          text-cp-neutral-0
        ;
      }
    }

    &--size {
      &-default {
        @apply
          text-[50px]
        ;
      }

      &-md {
        @apply
          text-[28px]
        ;
      }

      &-sm {
        @apply
          text-[16px]
        ;
      }
    }
  }
</style>
